import { QueryClient } from '@tanstack/react-query';

/** The app's one QueryClient (main.tsx provides it), so API writes can invalidate reads. */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: { retry: 1, staleTime: 30_000 },
    },
});
